import { render } from "./DiagnosticsCim10.vue?vue&type=template&id=1c2aff3c&scoped=true"
import script from "./DiagnosticsCim10.vue?vue&type=script&lang=js"
export * from "./DiagnosticsCim10.vue?vue&type=script&lang=js"

import "./DiagnosticsCim10.vue?vue&type=style&index=0&id=1c2aff3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2aff3c"]])

export default __exports__